<div class="app-es-ocr-quick-fix-manufacturer-details">
  <div class="app-es-ocr-quick-fix-manufacturer-details__header">
    <div class="app-es-ocr-quick-fix-manufacturer-details__header__left">
      <p
        class="app-es-ocr-quick-fix-manufacturer-details__header__title"
        [ngClass]="{ 'text-error': !isEditMode && isManufacturerExpectedFromCanada }"
      >
        {{ "MANUFACTURER" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.CN.SUB_TITLE_HINT' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-es-ocr-quick-fix-manufacturer-details__row">
    <p class="app-es-ocr-quick-fix-manufacturer-details__text">
      {{ "INFO.CN.SUB_TITLE_HINT" | translate }}
    </p>
  </div>

  <div class="app-es-ocr-quick-fix-manufacturer-details__row">
    <app-entity-unify-card
      *ngIf="!!seller && isEditMode"
      [entity]="seller"
      [formGroup]="formGroup"
      [code]="enumEntityModelCode.MANUFACTURER"
      [selectedValueControl]="formGroup.get('id')"
      [labelOverride]="'INFO.MF.USE_SE'"
      [isDesktop]="isDesktop"
    ></app-entity-unify-card>
  </div>

  <div class="app-es-ocr-quick-fix-manufacturer-details__row">
    <app-section-form-block-layout
      *ngIf="!!manufacturerFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!seller && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="manufacturerFields"
      [displayFields]="manufacturerDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(manufacturerFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.MANUFACTURER"
        [errors]="formErrors"
        [isShowState]="isShowManufacturerState"
        [isShowCountry]="false"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-es-ocr-quick-fix-manufacturer-details__hr" />

    <div class="app-es-ocr-quick-fix-manufacturer-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <div
    class="app-es-ocr-quick-fix-manufacturer-details__validation-hint text-error"
    *ngIf="!isEditMode && isManufacturerExpectedFromCanada"
  >
    {{ "BACK_ERROR.MANUFACTURER_EXPECTED_TO_BE_CANADIAN" | translate }}
  </div>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
